export const ON_GET_PROFILE_LOADING = 'ON_GET_PROFILE_LOADING';
export const ON_GET_PROFILE_LOADED = 'ON_GET_PROFILE_LOADED';
export const ON_GET_PROFILE_FAILURE = 'ON_GET_PROFILE_FAILURE';